// @flow
import styled from 'styled-components'
import { Layout } from 'antd'
const { Content } = Layout

export const StyledContent = styled(Content)`
  background: #fff;
  margin: 24px 16px;
  min-height: 280px;
  padding: 24px;
`



// WEBPACK FOOTER //
// ./src/components/view-earnings/style.js